import { addPersonalList } from '../../services/personalList';

export type CreatePersonalLineupArgs = {
  listType: number;
  personalLineup: Array<{ id: number; lcn: number }>;
};

export async function createPersonalLineup({ listType, personalLineup }: CreatePersonalLineupArgs): Promise<number> {
  // There is a limit on BE so we want to keep the string as short as possible
  const userPersonalLineup = personalLineup.map(({ id, lcn }) => ({ [id]: lcn }));

  const { id } = await addPersonalList({
    personalList: {
      // createdAt is needed in order to create unique entity just in case
      ksql: JSON.stringify({ UserPersonalLineup: userPersonalLineup, CreatedAt: Date.now() }),
      name: 'User Personal Lineup',
      partnerListType: listType,
    },
  });

  return id;
}
